import { useNavigate } from 'react-router-dom';
import { useI18n } from '@/hooks/useI18n';
import { routes } from '@/lib/routes';
import { AuthCard } from './components/AuthCard';

const DeniedPage = () => {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <AuthCard
      title={t('auth.denied.title')}
      description={t('auth.denied.text')}
      showTabs={false}
    >
      <div className="auth-mark" data-variant="denied" aria-hidden="true">
        ✕
      </div>
      <div className="auth-form">
        <button type="button" className="auth-primary" onClick={() => navigate(routes.home)}>
          {t('error.toHome')}
        </button>
        <button type="button" className="auth-link" onClick={() => navigate(routes.login)}>
          {t('auth.backToLogin')}
        </button>
      </div>
    </AuthCard>
  );
};

export default DeniedPage;
